import type {PageRouteConfig} from '@router';

import PinBasket from 'modules/Services/PromotionCenter/Pin/Basket/PinBasket';

export function createPromotionCenterPinBasketRoute(): PageRouteConfig {
  return {
    element: <PinBasket />,
    layout: {
      title: 'بررسی و پرداخت',
      hasNavigate: false,
      hasHeader: true,
      hasBack: true,
      hasLeftIcon: false,
      link: -1
    }
  };
}
